// US numbers only. A leading country code "1" is dropped once there are more
// than 10 digits, so "+1 555 555 5555" and "(555) 555-5555" normalize the same
// way without eating a real "1" while someone is mid-edit.
export function getPhoneDigits(value) {
	if (!value) return ''
	let digits = String(value).replace(/[^\d]/g, '')
	if (digits.length > 10 && digits.startsWith('1')) digits = digits.slice(1)
	return digits.slice(0, 10)
}

// Area codes never start with 0 or 1, so a 10-digit string that does is a
// mistyped number (often "1" plus only nine digits).
export function getPhoneNumberError(value) {
	const digits = getPhoneDigits(value)
	if (digits.length !== 10) return 'Please enter a 10-digit phone number.'
	if (!/^[2-9]/.test(digits)) return "Please enter a valid area code (it can't start with 0 or 1)."
	return ''
}

export function isValidPhoneNumber(value) {
	return !getPhoneNumberError(value)
}

export function formatPhoneNumber(value) {
	if (!value) return value
	const phoneNumber = getPhoneDigits(value)
	const phoneNumberLength = phoneNumber.length
	if (phoneNumberLength < 4) return phoneNumber
	if (phoneNumberLength < 7) {
		return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
	}
	return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
}
